import { Suspense, useEffect, useContext, useMemo, useCallback, useState } from "react";
import { Paper } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { CustomFormDialogType } from "../../../../../../../types/components/dialogProps.types";
import PlanHeader from "../../../../../../shared/enrollment/planCode/PlanHeader";
import { LazyBrandingActions, LazyCustomFormDialog, LazyPlanBranding } from "../../../../../../shared";
import {
	HealthBenefitBanner,
	IntercityFlexCarePlanBrandingLogo,
	IntercityGLTDPlanBrandingLogo
} from "../../../../../../../assets";
import { BrandingProps } from "../../../../../../../types/components/enrollmentProps.types";
import { AuthContext } from "../../../../../../../contexts";
import { CommonDetails, StandardDetails } from "../../../../../../../types/enrollment.types";
import { generateHealthPlanWaiveEnrollmentPayload } from "../../../../../../../utils/commonFunctions/groupEnrollment/enrollment";
import { api } from "../../../../../../../utils/api";
import { AddEnrollmentPayload } from "../../../../../../../utils/api/enrollment/enrollment";
import { trackPromise } from "react-promise-tracker";

const IntercityFlexCarePlanBranding = ({ status, openEnrollment, isActiveEnrollment }: BrandingProps) => {
	const [waiveReason, setWaiveReason] = useState("");
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const handleWaiveReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const { value } = event.target;
		setWaiveReason(value);
	};

	const [customFormDialogProps, setCustomFormDialogProps] = useState<CustomFormDialogType>();

	const handleWaiveEnrollment = useCallback(async () => {
		if (member === null || openEnrollment === null) {
			return;
		}
		const { standardDetails, commonDetails } = generateHealthPlanWaiveEnrollmentPayload(
			member,
			openEnrollment,
			waiveReason
		);
		if (isActiveEnrollment) {
			// console.log("isActiveEnrollment", isActiveEnrollment);
			commonDetails.enrollment_status = "WAIVED - WAITING FOR APPROVAL";
			debugger;
		}
		const enrollmentPayload: AddEnrollmentPayload = {
			standard_details: standardDetails,
			common_details: commonDetails
		};
		const response = await trackPromise(api.enrollment.addEnrollment(enrollmentPayload));
		const step = urlSearchParams.get("step");
		if (response) {
			history.push(`?step=${step}&stage=2`);
		}
	}, [history, isActiveEnrollment, member, openEnrollment, urlSearchParams, waiveReason]);

	const handleWaiveButtonClick = useCallback(() => {
		if (status.openEnrollment === "CLOSED") {
			alert("Enrollment has not been opened for this plan");
			return;
		}
		setCustomFormDialogProps(
			Object.assign({}, customFormDialogProps, {
				openDialog: true,
				title: "Are you sure want to waive this enrollment?",
				textfields: [
					{
						label: "Waive Reason",
						onChange: handleWaiveReasonChange,
						value: waiveReason,
						placeholder: "Enter your reason for waive"
					}
				],
				actions: [
					{
						label: "Cancel",
						callback: () =>
							setCustomFormDialogProps(Object.assign({}, customFormDialogProps, { openDialog: false }))
					},
					{
						label: "Yes",
						callback: () => {
							setCustomFormDialogProps(
								Object.assign({}, customFormDialogProps, {
									openDialog: false
								})
							);
							handleWaiveEnrollment();
						}
					}
				]
			})
		);
	}, [customFormDialogProps, handleWaiveEnrollment, status.openEnrollment, waiveReason]);

	const handleEnrollButtonClick = useCallback(() => {
		// console.log("openEnrollment", status);
		if (status.openEnrollment === "CLOSED") {
			alert("Enrollment has not been opened for this plan. Please contact your administrator");
		} else {
			// console.log("openEnrollment22", status);
			const step = urlSearchParams.get("step");
			history.push(`?step=${step}&stage=1`);
		}
	}, [history, urlSearchParams, status]);

	// console.log("custom", customFormDialogProps);

	return (
		<div className="paper-form-container">
			<Suspense fallback={<div />}>
				{customFormDialogProps ? <LazyCustomFormDialog customFormDialogProps={customFormDialogProps} /> : null}
			</Suspense>
			<Paper className="theme-border-radius paper-container" elevation={1}>
				<PlanHeader planName="Flex Care" planCode={openEnrollment?.plan?.plan_code} />
				<div className="theme-plan-section-margin" />
				<Suspense fallback={<div />}>
					<LazyPlanBranding imgSrc={IntercityFlexCarePlanBrandingLogo} />
				</Suspense>
				<Suspense fallback={<div />}>
					<LazyBrandingActions
						waiveButtonCallback={handleWaiveButtonClick}
						enrollButtonCallback={handleEnrollButtonClick}
					/>
				</Suspense>
			</Paper>
		</div>
	);
};

export default IntercityFlexCarePlanBranding;
